export default () => ({
  name: 'Player 1',
})
